export enum RequestStatus {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  None = 'NONE',
}

export enum ChainType {
  Testnet = 'testnet',
  Mainnet = 'mainnet',
}

export enum Languages {
  EnUs = 'en-us',
  ZhCn = 'zh-CN',
}

export enum Theme {
  Light = 'light',
  Dark = 'dark',
  LocalStorageThemeItem = 'theme',
}

export enum Periodicity {
  Minute = 'minute',
  Minute5 = 'minute5',
  Minute15 = 'minute15',
  Minute30 = 'minute30',
  Hour = 'hour',
  Hour4 = 'hour4',
  Hour8 = 'hour8',
  Day = 'day',
  Week = 'weel',
  Month = 'month',
}

export enum OrdersViewTabs {
  OpenOrders = 'orders',
  OrderHistory = 'orderHistory',
}

export type SelectOptionT = {
  label: string;
  value: string;
}

export type TranslateOptionsT = { 
  defaultTerm: string,
  key: string,
}